module.exports = __webpack_public_path__ + "img/1_uk.4793e6dc.svg";